import {MessageCodes} from "../MessageCodes";
import ResultTable from "../../../components/table/ResultTable";
import ResultText from "../ResultText";
import CheckCSName from "../CheckCSName";
import EmptyLine from "../EmptyLine";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultRow from "../../../components/table/ResultRow";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultBody from "../../../components/table/ResultBody";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import HecRasHelper from "../../../helpers/HecRasHelper";
import ToUpper from "../ToUpper";
import numWords from "num-words";
import {useUser} from "../../../context/UserContext";
import ResultView from "../../../components/ResultView";

export function B7({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.ST02.error_id: {
            return (
                <>
                    <ResultText>
                        {ToUpper(numWords(row?.data?.length))} ({row?.data?.length}) bridges at the following river stations do not follow the recommended bridge modeling methods listed below.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(15)}}>Bridge RS</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(55)}}>Missing Methods, Values</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row.data.map(x => {
                                    let count = x?.messages?.filter(x => x.missing_methods?.length > 0 && x.missing_values?.length > 0)?.length

                                    const rows = []
                                    x?.messages?.forEach(m => {
                                        let multipleRow = m.missing_methods?.length > 0 && m.missing_values?.length > 0
                                        let values = m.missing_methods
                                        if(!multipleRow && m.missing_methods?.length === 0) {
                                            values = m.missing_values
                                        }

                                        rows.push(
                                            <>
                                                <ResultRow>
                                                    <ResultBodyCell style={{textAlign: 'left', verticalAlign: 'top'}} rowSpan={multipleRow ? 2 : 1}>
                                                        <CheckCSName csName={x.cross_section} />
                                                    </ResultBodyCell>
                                                    <ResultBodyCell>
                                                        {values?.join(', ')}
                                                    </ResultBodyCell>
                                                </ResultRow>
                                                {
                                                    multipleRow && (
                                                        <ResultRow>
                                                            <ResultBodyCell>
                                                                {m.missing_values?.join(', ')}
                                                            </ResultBodyCell>
                                                        </ResultRow>
                                                    )
                                                }
                                            </>
                                        )
                                    })

                                    return rows
                                })
                            }
                        </ResultBody>
                    </ResultTable>

                </>
            )
        }
        case MessageCodes.Internal.ST03.error_id: {
            return (
                <>
                    <ResultText>
                        The maximum submergence ratio of {row.data.length} bridge structures at the following river stations are different than the default value {settings?.defaults?.max_submergence_ratio}
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(15)}}>River Station</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(15)}}>Max Sub. Ratio</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row.data.map(r => (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left',}}><CheckCSName csName={r.cross_section} /></ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{HecRasHelper.isUndefined(r.ratio, '-')}</ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Internal.ST04.error_id: {
            return (
                <>
                    <ResultText>
                        The maximum submergence ratio of {row.data.length} culvert structures at the following river stations are different than the default value {settings?.defaults?.max_submergence_ratio}
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(15)}}>River Station</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(15)}}>Max Sub. Ratio</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row.data.map(r => (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left'}}><CheckCSName csName={r.cross_section} /></ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{HecRasHelper.isUndefined(r.ratio, '-')}</ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}